
import React from 'react';
import { Check, X } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';
import { Treatment } from '@/data/treatmentData';

interface TreatmentItemProps {
  treatment: Treatment;
  onToggle: (id: string) => void;
  onPriceChange: (id: string, value: string) => void;
}

const TreatmentItem: React.FC<TreatmentItemProps> = ({
  treatment,
  onToggle,
  onPriceChange
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center py-3 border-b last:border-b-0">
      <div className="flex items-center flex-1">
        <Switch
          checked={treatment.enabled || false}
          onCheckedChange={() => onToggle(treatment.id)}
          className="mr-3"
        />
        <div>
          <h4 className="font-medium">{treatment.name}</h4>
          <p className="text-sm text-muted-foreground">{treatment.description}</p>
        </div>
      </div>
      
      <div className="flex items-center mt-2 md:mt-0">
        <div className="w-[120px] pr-3">
          <Input 
            type="number"
            disabled={!treatment.enabled}
            value={treatment.customPrice !== undefined ? treatment.customPrice : treatment.defaultPrice || ''}
            onChange={(e) => onPriceChange(treatment.id, e.target.value)}
            placeholder="Price"
            className="text-right"
          />
        </div>
        
        <span className="w-8 text-muted-foreground">
          {treatment.enabled ? 
            <Check className="h-5 w-5 text-green-500" /> : 
            <X className="h-5 w-5 text-muted-foreground" />
          }
        </span>
      </div>
    </div>
  );
};

export default TreatmentItem;
